import {
  Breakpoint,
  getCurrentBreakpoint,
} from '@/utils/breakpoints';

export interface PlayerSize {
  width: number;
  height: number;
}

export function calculatePlayerSize(windowWidth: number): PlayerSize {
  let newWidth = 0;
  const breakpoint = getCurrentBreakpoint(windowWidth);

  switch (breakpoint) {
    case Breakpoint.SM:
    case Breakpoint.MD:
    // On smaller screens, take ~90% of available space. Some space subtracted for margins etc.
      newWidth = windowWidth * 0.88;
      break;
    case Breakpoint.LG:
    case Breakpoint.XL:
    case Breakpoint.XXL:
    // On larger screens, player width should take the full allowed content width
      newWidth = 960;
      break;
    default:
    // Default to large screen if something is weird
      newWidth = 960;
      break;
  }
  // Player height should conform to 16:9 ratio given the new width.
  // 16/9=1.78 or in other words, the aspect ratio is 1.78:1.
  const newHeight = (newWidth / 1.78);

  return {
    width: newWidth,
    height: newHeight,
  };
}
